export default "__VITE_ASSET__CfEMZiWj__"